'use client';

import { useDrawer } from '@cat-ecom/pcc-components';
import {
  FC,
  PropsWithChildren,
  createContext,
  useContext,
  useMemo,
  useState
} from 'react';

type UseDrawerType = ReturnType<typeof useDrawer>;

type FilterAndSortDrawerContextType = UseDrawerType & {
  setOnClose: React.Dispatch<React.SetStateAction<() => void>>;
};

const FilterAndSortDrawerContext =
  createContext<FilterAndSortDrawerContextType>(null);

export const useFilterAndSortDrawer = () =>
  useContext(FilterAndSortDrawerContext);

export const FilterAndSortDrawerProvider: FC<PropsWithChildren> = ({
  children
}) => {
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  const [onClose, setOnClose] = useState<() => void>(() => () => {});

  const storeInfoDrawer = useDrawer({
    onClose: () => onClose()
  });

  const contextValues = useMemo(
    () => ({ ...storeInfoDrawer, setOnClose }),
    [storeInfoDrawer, setOnClose]
  );

  return (
    <FilterAndSortDrawerContext.Provider value={contextValues}>
      {children}
    </FilterAndSortDrawerContext.Provider>
  );
};
